import { Link } from "react-router-dom";

import { TrainingsList } from "@/features/chats";
import { useTrainerChatOutlet } from "./TrainerChatUserLayout";

import styles from "./TrainerChatTrainingsPage.module.scss";

export const TrainerChatTrainingsPage = () => {
  const { profile } = useTrainerChatOutlet();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Link to=".." className={styles.back}>
          ← Назад к клиенту
        </Link>
        <h3>Программа тренировок</h3>
        <span className={styles.placeholder} />
      </div>

      <TrainingsList trainings={profile.trainings ?? []} />
    </div>
  );
};









